import React from "react";

/**
 * Comments Component
 * Reusable comments section for T&M forms with character limit and counter
 *
 * @param {Object} props
 * @param {Object} props.data - Form data object containing the comments field
 * @param {Function} [props.onChange] - Callback when field value changes
 * @param {boolean} [props.readOnly] - Whether the field is read-only
 * @param {number} [props.maxLength] - Maximum character length
 * @param {string} [props.fieldName] - Key on data for the comments value
 * @param {string} [props.title] - Section heading label
 * @param {string} [props.placeholder] - Textarea placeholder text
 */
const Comments = ({
  data,
  onChange,
  readOnly = false,
  maxLength = 184,
  fieldName = "comments",
  title = "Comments",
  placeholder = "Add any additional comments or notes...",
}) => {
  const currentLength = data?.[fieldName]?.length || 0;
  const remainingChars = maxLength - currentLength;
  const emptyLabel = `No ${title.toLowerCase()}`;

  return (
    <div className="border-b pb-4">
      <h2 className="text-lg font-semibold text-gray-700 mb-2">
        {title} {readOnly && "(Read-only)"}
      </h2>
      {readOnly ? (
        <div className="border rounded p-4 bg-gray-50">
          <p className="text-gray-700">{data?.[fieldName] || emptyLabel}</p>
        </div>
      ) : (
        <>
          <textarea
            className="w-full border rounded p-2 caret-black"
            rows={3}
            placeholder={placeholder}
            value={data?.[fieldName] || ""}
            maxLength={maxLength}
            onChange={(e) =>
              onChange?.({ ...data, [fieldName]: e.target.value })
            }
          />
          <div className="text-xs text-gray-500 mt-1 text-right">
            {remainingChars} characters remaining
          </div>
        </>
      )}
    </div>
  );
};

export default Comments;
